
import AbrirVentana from "../../reductores/acciones/widgets/AbrirVentana";
import VentanaItem from "../../../isp.pantalla.principal.items/reductores/ventanas/VentanaItem";
import VentanaQueryItems from "../../../isp.pantalla.principal.items/reductores/ventanas/VentanaQueryItems";


export default function MenuItemsCatalogo(dispatch) {
    return [
        {
            label: "Nuevo Item a Facturar",
            icon: "pi pi-fw pi-plus",
            command: () => {
                const nuevaVentana = new VentanaItem();
                dispatch(new AbrirVentana(nuevaVentana));
            },
        },
        {
            label: "Listar Items a Facturar",
            icon: "pi pi-fw pi-list",
            command: () => {
                const nuevaVentana = new VentanaQueryItems;
                dispatch(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaQueryClientesAFacturar())
            },
        },
    ];
}
